<template>
  <div class="banner">
    <div class="text-wrapper">
      <p class="heading-orange">
        Autodoładowanie w Orange
      </p>
      <p class="heading-main">
        Twój telefon doładuje się sam!
      </p>
      <p class="text">
        Włącz Autodoładowanie dla tego numeru
      </p>
      <button class="btn" type="button" @click="goToAutotopup">Włącz Autodoładowanie</button>
    </div>
  </div>
</template>

<script>
import { ROUTING } from '@/orange/const/routing.const'

export default {
  name: 'TopupBanner',
  methods: {
    goToAutotopup () {
      this.$router.push(ROUTING.topup.auto.step1)
    }
  }
}
</script>

<style lang="scss" scoped src="../../assets/scss/components/_banner.scss"></style>
